import React from 'react'

export const RateContext = React.createContext(null)
